// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 642 ? "94a7ad86" : chunkId) + "." + {"642":"2a75491b48f86536","680":"ca4eba91ed108053"}[chunkId] + ".js";
};